import AppLayout from "./Layout";
import { useUI } from "./UIContext";
import { ReactComponent as LockIcon } from "./assets/lock.svg";

export default function NotAuthorizedPage() {
  const { setLocation } = useUI();
  return (
    <AppLayout
      header={
        <div className="flex flex-col items-center justify-center h-full">
          <div className="font-bold text-xl">Not Authorized</div>
        </div>
      }
    >
      <div className="flex flex-col items-center justify-center font-bold">
        <div>
          <LockIcon width="60px" height="70px" />
        </div>
        <div>Not Authorized</div>
        <button
          className="text-blue-700 font-semibold"
          onClick={() => setLocation("/")}
        >
          Return Home
        </button>
      </div>
    </AppLayout>
  );
}
